// BookingFlow.tsx
import {
   Row,
   Col,
   Tabs,
   Form,
   Input,
   Button,
   DatePicker,
   Card,
   Select,
   Checkbox,
   InputNumber,
   Radio,
   notification
} from 'antd'
import { useEffect, useMemo, useState } from 'react'
import locale from 'antd/es/date-picker/locale/vi_VN'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import { useStore } from 'src/hooks'
import ConfirmBookingModal from './ConfirmBookingModal'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { disabledDate, disabledDateTime } from 'src/helpers/functions'
import { ORDER_TYPE } from 'src/helpers/constants'

const { TabPane } = Tabs

const BookingFlow = observer(() => {
   const rule = useMemo(() => createValidationRules(), [i18n.language])
   const OrderStore = useStore('OrderStore')

   const [selectedTab, setSelectedTab] = useState('SHARED')
   const [startRouteDirection, setStartRouteDirection] = useState<'29' | '36'>('29')

   const [loading, setLoading] = useState(false)
   const [confirmVisible, setConfirmVisible] = useState(true)
   const [confirmData, setConfirmData] = useState<any>(null)

   const tripDirection = startRouteDirection === '29' ? 1 : 2
   const [sharedForm] = Form.useForm()
   const [coverForm] = Form.useForm()
   const [deliveryForm] = Form.useForm()

   const [shareRoundTrip, setShareRoundTrip] = useState(false)
   const [coverRoundTrip, setCoverRoundTrip] = useState(false)
   useEffect(() => {
      fetchData()
   }, [])

   const fetchData = async () => {
      setLoading(true)
      try {
         OrderStore.loadInitialBookingDataWeb()
      } finally {
         setLoading(false)
      }
   }

   useEffect(() => {
      console.log('OrderStore.provinceDefaultWebOrderStore.provinceDefaultWeb: ', OrderStore.provinceDefaultWeb)

      //@ts-ignore
      if (OrderStore.provinceDefaultWeb?.from?.code) {
         //@ts-ignore
         setStartRouteDirection(OrderStore.provinceDefaultWeb.from.code as '29' | '36')
      }
   }, [OrderStore.provinceDefaultWeb])

   const renderOrderType = (values: any) => {
      switch (selectedTab) {
         case 'SHARED':
            return ORDER_TYPE.SHARED
         case 'COVER':
            if (values.selectedTypeCar === '5') {
               if (values.returnTime) {
                  //Khu hoi
                  return ORDER_TYPE.ROUND_TRIP_5_SEATS
               }
               return ORDER_TYPE.PRIVATE_5_SEATS
            } else {
               if (values.returnTime) {
                  //Khu hoi
                  return ORDER_TYPE.ROUND_TRIP_7_SEATS
               }
               return ORDER_TYPE.PRIVATE_7_SEATS
            }
         case 'DELIVERY':
            return values.typeDelivery === 'small' ? ORDER_TYPE.DELIVERY_SMALL : ORDER_TYPE.DELIVERY_LARGE
         default:
            return ORDER_TYPE.SHARED
      }
   }

   const onSubmit = (orderType: string) => (values: any) => {
      const body = {
         fromId: values.from,
         toId: values.to,
         selectedTab: orderType, //Tab hiện tại,
         tripSelected: {
            ...OrderStore.tripDetail,
            fromDistrict: values.from,
            toDistrict: values.to
         },
         routeId: OrderStore.tripDetail?.id,
         pickupLocationAddress: values.pickup || '',
         // pickupLocationLat: dataPickup?.lat || '',
         // pickupLocationLng: dataPickup?.lon || '',
         dropoffLocationAddress: values.dropoff || '',
         // dropoffLocationLat: dataDropoff?.lat || '',
         // dropoffLocationLng: dataDropoff?.lon || '',
         orderType: renderOrderType(values),
         typeDelivery: values.typeDelivery,
         selectedTypeCar: values.selectedTypeCar,
         promotionCode: '',
         promotionDiscount: 0,
         departureDateTime: values?.departureDateTime?.toISOString(),
         returnDateTime: values?.returnDateTime?.toISOString(), // Optional, nếu có sẽ auto-detect round trip
         tripDirection: startRouteDirection == '29' ? 1 : 2, // Auto-set

         passengerCount: values.passengerCount,
         receiverName: values.receivedName,
         receiverPhone: values.receivedPhone,
         customerName: values.customerName,
         customerPhone: values.customerPhone
      }
      const payload = {
         ...body,
         tripDirection,
         pickupLocationLat: '0',
         pickupLocationLng: '0',
         dropoffLocationLat: '0',
         dropoffLocationLng: '0',
         from: fromOptions.find((item: any) => values.from == item?.id),
         to: toOptions.find((item: any) => values.to == item?.id),
         carType: values.carType,
         // packageType: values.packageType,

         notes: values.notes,
         promotionCode: '',
         promotionDiscount: 0
      }
      //Gọi Api lấy giá => Show modal confirm giá
      OrderStore.previewOrderPriceWeb(body)
      setConfirmData(payload)
      setConfirmVisible(true)
   }
   const swapFromToAndFetchTrip = () => {
      const forms = [sharedForm, coverForm, deliveryForm]

      forms.forEach((form) => {
         const from = form.getFieldValue('from')
         const to = form.getFieldValue('to')

         if (from && to) {
            const nextValues = { from: to, to: from }

            // 1. set lại form
            form.setFieldsValue(nextValues)

            // 2. gọi lại API trip detail
            handleFetchTripDetail(nextValues, nextValues)
         }
      })
   }
   useEffect(() => {
      swapFromToAndFetchTrip()
   }, [startRouteDirection])

   const fromOptions = useMemo(() => {
      if (startRouteDirection === '29') return OrderStore.locationsHnWeb || []
      if (startRouteDirection === '36') return OrderStore.locationsThWeb || []
      return []
   }, [startRouteDirection, OrderStore.locationsHnWeb, OrderStore.locationsThWeb])

   const toOptions = useMemo(() => {
      if (startRouteDirection === '29') return OrderStore.locationsThWeb || []
      if (startRouteDirection === '36') return OrderStore.locationsHnWeb || []
      return []
   }, [startRouteDirection, OrderStore.locationsHnWeb, OrderStore.locationsThWeb])

   console.log('toOptions', toOptions)
   /* ===================== FORMS ===================== */
   const FromToFields = () => {
      return (
         <>
            <Col xs={24} md={8} lg={6}>
               <Form.Item name="from" label="Điểm đón" required rules={[rule.requiredSelect]}>
                  <Select placeholder="Chọn điểm đón" allowClear style={{ fontWeight: '400' }}>
                     {fromOptions.map((item) => (
                        <Select.Option key={item?.id} value={item?.id}>
                           {item?.name}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>
            </Col>
            <Col xs={24} md={8} lg={6}>
               <Form.Item name="to" label="Điểm trả" required rules={[rule.requiredSelect]}>
                  <Select placeholder="Chọn điểm trả" allowClear style={{ fontWeight: '400' }}>
                     {toOptions.map((item) => (
                        <Select.Option key={item?.id} value={item?.id}>
                           {item?.name}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>
            </Col>
         </>
      )
   }

   const DonTraFields = () => (
      <>
         <Col xs={24} md={8} lg={6}>
            <Form.Item name="pickup" label="Chi tiết điểm đón" required rules={[rule.requiredEnter]}>
               <Input placeholder="Nhập chi tiết điểm đón" maxLength={100} />
            </Form.Item>
         </Col>
         <Col xs={24} md={8} lg={6}>
            <Form.Item name="dropoff" label="Chi tiết điểm trả" required rules={[rule.requiredEnter]}>
               <Input placeholder="Nhập chi tiết điểm trả" maxLength={100} />
            </Form.Item>
         </Col>
      </>
   )

   const CustomerFields = () => (
      <>
         <Col xs={24} md={8} lg={6}>
            <Form.Item name="customerName" label="Tên khách hàng" required rules={[rule.requiredEnter]}>
               <Input placeholder="Nhập tên khách hàng" maxLength={100} />
            </Form.Item>
         </Col>
         <Col xs={24} md={8} lg={6}>
            <Form.Item
               name="customerPhone"
               label="SĐT khách hàng"
               required
               rules={[rule.requiredEnter, rule.phoneRule]}
            >
               <Input type="tel" placeholder="Nhập SĐT khách hàng" maxLength={13} minLength={10} />
            </Form.Item>
         </Col>
      </>
   )

   const NoteField = () => (
      <Col xs={24} md={12}>
         <Form.Item name="notes" label="Ghi chú">
            <Input maxLength={256} placeholder="Nhập nội dung..." />
         </Form.Item>
      </Col>
   )

   const handleFetchTripDetail = (changedValues: any, allValues: any) => {
      if ('from' in changedValues || 'to' in changedValues) {
         const { from, to } = allValues

         // Cập nhật ngược lại Store để các Tab khác cũng biết điểm đón/trả đã chọn
         // OrderStore.updateProvinceDefault({
         //    fromId: from,
         //    toId: to
         // });

         if (from && to) {
            OrderStore.getTripDetailWebFromTo(from, to)
         }
      }
   }

   /* ===================== XE GHÉP ===================== */
   const XeGhepForm = () => {
      return (
         <Form
            form={sharedForm}
            layout="vertical"
            preserve
            onFinish={onSubmit('SHARED')}
            onValuesChange={(changedValues, allValues) => {
               // Logic cũ của bạn
               if ('roundTrip' in changedValues) {
                  setShareRoundTrip(changedValues.roundTrip)
                  if (!changedValues.roundTrip) sharedForm.setFieldsValue({ returnTime: null })
               }

               // Logic mới: Gọi API khi điểm đón/trả thay đổi
               handleFetchTripDetail(changedValues, allValues)
            }}
         >
            <Row gutter={12} className="gx-flex-row">
               <FromToFields />

               <DonTraFields />
               <CustomerFields />
               <Col xs={24} md={8} lg={6}>
                  <Form.Item name="passengerCount" label="Số người" rules={[rule.requiredEnter]}>
                     <InputNumber
                        type="tel"
                        min={1}
                        max={3}
                        style={{ width: '100%' }}
                        placeholder="Tối đa 3 người"
                        maxLength={1}
                     />
                  </Form.Item>
               </Col>

               <Col xs={24} md={8} lg={6}>
                  <Form.Item
                     name="departureDateTime"
                     label="Thời gian đi"
                     rules={[
                        rule.requiredSelect,
                        {
                           validator(_, value) {
                              if (!value) return Promise.resolve()
                              if (moment(value).isSameOrAfter(moment(), 'minute')) return Promise.resolve()
                              return Promise.reject(new Error('Không được chọn thời điểm trong quá khứ'))
                           }
                        }
                     ]}
                  >
                     <DatePicker
                        showTime
                        format="HH:mm DD-MM-YYYY"
                        locale={locale}
                        style={{ width: '100%' }}
                        disabledDate={disabledDate} // <--- Gán hàm trả về boolean vào đây
                        disabledTime={disabledDateTime} // <--- Gán hàm trả về object vào đây
                        onChange={() => sharedForm.validateFields(['returnTime'])}
                     />
                  </Form.Item>
               </Col>

               <NoteField />
               <Col xs={24} md={8} lg={6}>
                  {shareRoundTrip && (
                     <Form.Item
                        name="returnTime"
                        label="Thời gian về"
                        dependencies={['departureDateTime']}
                        rules={[
                           rule.requiredSelect,
                           {
                              validator(_, value) {
                                 if (!value) return Promise.resolve()
                                 if (moment(value).isSameOrAfter(moment(), 'minute')) return Promise.resolve()
                                 return Promise.reject(new Error('Không được chọn thời điểm trong quá khứ'))
                              }
                           },
                           ({ getFieldValue }) => ({
                              validator(_, value) {
                                 const start = getFieldValue('departureDateTime')
                                 if (!value || !start) return Promise.resolve()
                                 if (moment(value).isSameOrAfter(moment(start))) return Promise.resolve()
                                 return Promise.reject(new Error('Thời gian về phải bằng hoặc sau thời gian đi!'))
                              }
                           })
                        ]}
                     >
                        <DatePicker
                           showTime
                           format="HH:mm DD-MM-YYYY"
                           locale={locale}
                           style={{ width: '100%' }}
                           disabledDate={disabledDate} // <--- Gán hàm trả về boolean vào đây
                           disabledTime={disabledDateTime} // <--- Gán hàm trả về object vào đây
                           onChange={() => sharedForm.validateFields(['departureDateTime'])}
                        />
                     </Form.Item>
                  )}
               </Col>
            </Row>
            <Form.Item
               name="roundTrip"
               valuePropName="checked"
               extra={
                  <span
                     style={{ fontWeight: '400', fontSize: 11, fontStyle: 'italic', color: 'red' }}
                  >{`Quý khách vui lòng chọn Bao xe nếu đặt trên 3 người`}</span>
               }
            >
               <Checkbox>Khứ hồi</Checkbox>
            </Form.Item>
            <div style={{ textAlign: 'center' }}>
               <Button htmlType="submit" type="primary" style={{ color: '#EDBB1D', fontWeight: 600 }}>
                  ĐẶT XE NGAY
               </Button>
            </div>
         </Form>
      )
   }

   /* ===================== BAO XE ===================== */

   const BaoXeForm = () => {
      return (
         <Form
            form={coverForm}
            layout="vertical"
            preserve
            onFinish={onSubmit('COVER')}
            onValuesChange={(changedValues, allValues) => {
               // Logic cũ của bạn
               if ('roundTrip' in changedValues) {
                  setCoverRoundTrip(changedValues.roundTrip)
                  if (!changedValues.roundTrip) coverForm.setFieldsValue({ returnTime: null })
               }

               // Logic mới: Gọi API khi điểm đón/trả thay đổi
               handleFetchTripDetail(changedValues, allValues)
            }}
         >
            <Row gutter={12} className="gx-flex-row">
               <FromToFields />
               <DonTraFields />
               <CustomerFields />

               <Col xs={24} md={8} lg={6}>
                  <Form.Item name="carType" label="Loại xe" required rules={[rule.requiredEnter]}>
                     <Select placeholder="Chọn xe 5/7 chỗ" style={{ fontWeight: '400' }}>
                        <Select.Option value={5}>5 chỗ</Select.Option>
                        <Select.Option value={7}>7 chỗ</Select.Option>
                     </Select>
                  </Form.Item>
               </Col>
               <Col xs={24} md={8} lg={6}>
                  <Form.Item
                     name="departureDateTime"
                     label="Thời gian đi"
                     required
                     rules={[
                        rule.requiredSelect,
                        {
                           validator(_, value) {
                              if (!value) return Promise.resolve()
                              if (moment(value).isSameOrAfter(moment(), 'minute')) return Promise.resolve()
                              return Promise.reject(new Error('Không được chọn thời điểm trong quá khứ'))
                           }
                        }
                     ]}
                  >
                     <DatePicker
                        showTime
                        format="HH:mm DD-MM-YYYY"
                        locale={locale}
                        style={{ width: '100%' }}
                        disabledDate={disabledDate} // <--- Gán hàm trả về boolean vào đây
                        disabledTime={disabledDateTime} // <--- Gán hàm trả về object vào đây
                        onChange={() => coverForm.validateFields(['returnTime'])}
                     />
                  </Form.Item>
               </Col>

               <NoteField />
               {coverRoundTrip && (
                  <Col xs={24} md={8} lg={6}>
                     <Form.Item
                        name="returnTime"
                        required
                        label="Thời gian về"
                        dependencies={['departureDateTime']}
                        rules={[
                           rule.requiredSelect,
                           {
                              validator(_, value) {
                                 if (!value) return Promise.resolve()
                                 if (moment(value).isSameOrAfter(moment(), 'minute')) return Promise.resolve()
                                 return Promise.reject(new Error('Không được chọn thời điểm trong quá khứ'))
                              }
                           },
                           ({ getFieldValue }) => ({
                              validator(_, value) {
                                 const start = getFieldValue('departureDateTime')
                                 if (!value || !start) return Promise.resolve()
                                 if (moment(value).isSameOrAfter(moment(start))) return Promise.resolve()
                                 return Promise.reject(new Error('Thời gian về phải bằng hoặc sau thời gian đi!'))
                              }
                           })
                        ]}
                     >
                        <DatePicker
                           showTime
                           format="HH:mm DD-MM-YYYY"
                           locale={locale}
                           style={{ width: '100%' }}
                           disabledDate={disabledDate} // <--- Gán hàm trả về boolean vào đây
                           disabledTime={disabledDateTime} // <--- Gán hàm trả về object vào đây
                           onChange={() => coverForm.validateFields(['departureDateTime'])}
                        />
                     </Form.Item>
                  </Col>
               )}
            </Row>

            <Form.Item name="roundTrip" valuePropName="checked">
               <Checkbox>Khứ hồi</Checkbox>
            </Form.Item>

            <div style={{ textAlign: 'center' }}>
               <Button htmlType="submit" type="primary" style={{ color: '#EDBB1D', fontWeight: 600 }}>
                  ĐẶT XE NGAY
               </Button>
            </div>
         </Form>
      )
   }

   /* ===================== GỬI ĐỒ ===================== */

   const GuiDoForm = () => {
      return (
         <Form
            form={deliveryForm}
            layout="vertical"
            preserve
            onFinish={onSubmit('DELIVERY')}
            onValuesChange={(changedValues, allValues) => {
               // Logic cũ của bạn

               // Logic mới: Gọi API khi điểm đón/trả thay đổi
               handleFetchTripDetail(changedValues, allValues)
            }}
         >
            <Row gutter={12} className="gx-flex-row">
               <FromToFields />
               <DonTraFields />
               <CustomerFields />
               <Col xs={24} md={8} lg={6}>
                  <Form.Item name="receiverName" label="Tên người nhận" required rules={[rule.requiredEnter]}>
                     <Input placeholder="Tên người nhận" maxLength={100} />
                  </Form.Item>
               </Col>
               <Col xs={24} md={8} lg={6}>
                  <Form.Item
                     name="receiverPhone"
                     label="SĐT người nhận"
                     required
                     rules={[rule.requiredEnter, rule.phoneRule]}
                  >
                     <Input type="tel" placeholder="SĐT người nhận" maxLength={13} minLength={10} />
                  </Form.Item>
               </Col>
            </Row>

            <Row gutter={12} className="gx-flex-row">
               <Col xs={24} md={8} lg={6}>
                  <Form.Item
                     name="departureDateTime"
                     label="Thời gian gửi"
                     required
                     rules={[
                        rule.requiredSelect,
                        {
                           validator(_, value) {
                              if (!value) return Promise.resolve()
                              if (moment(value).isSameOrAfter(moment(), 'minute')) return Promise.resolve()
                              return Promise.reject(new Error('Không được chọn thời điểm trong quá khứ'))
                           }
                        }
                     ]}
                  >
                     <DatePicker
                        showTime
                        format="HH:mm DD-MM-YYYY"
                        locale={locale}
                        style={{ width: '100%' }}
                        disabledDate={disabledDate} // <--- Gán hàm trả về boolean vào đây
                        disabledTime={disabledDateTime} // <--- Gán hàm trả về object vào đây
                     />
                  </Form.Item>
               </Col>

               <Col xs={24} md={8} lg={6}>
                  <Form.Item name="typeDelivery" label="Loại hàng" required rules={[rule.requiredSelect]}>
                     <Radio.Group buttonStyle="solid">
                        <Radio.Button value="small">{`Nhỏ (<25cm)`}</Radio.Button>
                        <Radio.Button value="large">{`To`}</Radio.Button>
                     </Radio.Group>
                  </Form.Item>
               </Col>
               <NoteField />
            </Row>

            <div style={{ textAlign: 'center' }}>
               <Button htmlType="submit" type="primary" style={{ color: '#EDBB1D', fontWeight: 600 }}>
                  ĐẶT XE NGAY
               </Button>
            </div>
         </Form>
      )
   }

   const handCreateOrderWeb = async (body: any) => {
      console.log('API PAYLOAD:', body)

      const result = await OrderStore.createOrderWeb(body)
      if (result) {
         notification.success({
            message: 'Đặt chuyến thành công',
            description: 'Chúng tôi đang tìm kiếm tài xế cho bạn. Cùng chờ đợi nha.'
         })

         // ✅ RESET TẤT CẢ FORM
         sharedForm.resetFields()
         coverForm.resetFields()
         deliveryForm.resetFields()

         // (tuỳ chọn) reset state phụ
         setSelectedTab('SHARED')
         setConfirmVisible(false)
         setConfirmData(null)
      }
   }
   return (
      <Card>
         <Row gutter={12} className="gx-flex-row" style={{ marginBottom: 12 }}>
            <Col xs={12} md={9} lg={8}>
               <Checkbox
                  // style={{ fontSize: 12 }}
                  checked={startRouteDirection === '29'}
                  onChange={() => setStartRouteDirection('29')}
               >
                  Hà Nội↔Thanh Hóa
               </Checkbox>
            </Col>
            <Col xs={12} md={8}>
               <Checkbox
                  // style={{ fontSize: 12 }}
                  checked={startRouteDirection === '36'}
                  onChange={() => setStartRouteDirection('36')}
               >
                  Thanh Hóa↔Hà Nội
               </Checkbox>
            </Col>
         </Row>
         <Tabs
            activeKey={selectedTab}
            onChange={setSelectedTab}
            size="small"
            style={{ fontWeight: 600 }}
            destroyInactiveTabPane={false}
         >
            <TabPane tab="XE GHÉP" key="SHARED">
               <XeGhepForm />
            </TabPane>
            <TabPane tab="BAO XE" key="COVER">
               <BaoXeForm />
            </TabPane>
            <TabPane tab="GỬI ĐỒ" key="DELIVERY">
               <GuiDoForm />
            </TabPane>
         </Tabs>
         {confirmData && (
            <ConfirmBookingModal
               visible={confirmVisible}
               data={confirmData}
               onCancel={() => setConfirmVisible(false)}
               onConfirm={handCreateOrderWeb}
            />
         )}
      </Card>
   )
})

export default BookingFlow
